import dashboard from '@/pages/dashboard/_locales/zh-CN';
import home from '@/pages/home/_locales/zh-CN';
import intelligence from '@/pages/intelligence/_locales/zh-CN';
import globalpedia from '@/pages/globalpedia/_locales/zh-CN';
import opinion from '@/pages/opinion/_locales/zh-CN'; 
import datalab from '@/pages/datalab/_locales/zh-CN';
import aigc from '@/pages/aigc/_locales/zh-CN';
import benchmark from '@/pages/benchmark/_locales/zh-CN';
import strategic from '@/pages/strategic/_locales/zh-CN';
import userCenter from '@/pages/user-center/_locales/zh-CN';

export default {
  ...dashboard,
  ...home,
  ...intelligence,
  ...globalpedia,
  ...opinion,
  ...datalab,
  ...aigc,
  ...benchmark,
  ...strategic,
  ...userCenter,
};
